export class RoutePosition {
  public lat: number;
  public lon: number;
}
